import React, { useEffect, useState } from "react";
import axios from "axios";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";
import { Form, Row, Col, Button, Table, Spinner, Alert } from "react-bootstrap";

export default function ViewPaidDays() {
  const { user } = useAuth();

  const [workingDaysList, setWorkingDaysList] = useState([]);
  const [selectedWorkingDaysId, setSelectedWorkingDaysId] = useState("");
  const [attendanceData, setAttendanceData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [calculateLoading, setCalculateLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [selectedResources, setSelectedResources] = useState([]);
  const [submitting, setSubmitting] = useState(false);
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

  const toggleResource = (row) => {
    setSelectedResources((prev) => {
      const exists = prev.find((r) => r.resourceId === row.resourceId);

      if (exists) {
        return prev.filter((r) => r.resourceId !== row.resourceId);
      }

      return [
        ...prev,
        {
          resourceId: row.resourceId,
          paidDays: row.salaryDays,
        },
      ];
    });
  };
  const toggleSelectAll = (checked) => {
    if (checked) {
      setSelectedResources(
        activeEmployees.map((row) => ({
          resourceId: row.resourceId,
          paidDays: row.salaryDays,
        })),
      );
    } else {
      setSelectedResources([]);
    }
  };

  const submitSelectedAttendance = async () => {
    if (selectedResources.length === 0) {
      alert("Please select at least one employee");
      return;
    }

    try {
      setSubmitting(true);

      const payload = {
        workingDaysId: selectedWorkingDaysId,
        employees: selectedResources,
      };

      await axios.post(`${Base_URL}/SalaryProcess/BulkUserAttendance`, payload);

      setSelectedResources([]);
      // fetchAttendance(); // optional refresh
    } catch (error) {
      console.error("Error submitting attendance", error);
      alert("Failed to submit attendance");
    } finally {
      setSubmitting(false);
    }
  };

  /* -----------------------------------------
     Fetch Working Days for Dropdown
  ----------------------------------------- */
  const fetchWorkingDays = async () => {
    try {
      const res = await axios.get(
        `${Base_URL}/Attendance/GetWorkindDaysForAttendance/${user?.organisationId}`,
      );
      setWorkingDaysList(res.data || []);
    } catch (error) {
      console.error("Error fetching working days", error);
    }
  };

  /* -----------------------------------------
     Calculate Attendance
  ----------------------------------------- */
  const calculateAttendance = async () => {
    if (!selectedWorkingDaysId) return;

    try {
      setCalculateLoading(true);
      setSuccessMessage("");

      await axios.post(
        `${Base_URL}/Attendance/CreateAttendances/${selectedWorkingDaysId}`,
      );

      setSuccessMessage("Attendance calculated successfully.");
    } catch (error) {
      console.error("Error calculating attendance", error);
    } finally {
      setCalculateLoading(false);
    }
  };

  /* -----------------------------------------
     Fetch Attendance Summary
  ----------------------------------------- */
  const fetchAttendance = async () => {
    if (!selectedWorkingDaysId) return;

    try {
      setLoading(true);
      const res = await axios.get(
        `${Base_URL}/Attendance/GetAttendance/${selectedWorkingDaysId}`,
      );
      setAttendanceData(res.data || []);
    } catch (error) {
      console.error("Error fetching attendance", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.organisationId) {
      fetchWorkingDays();
    }
  }, [user?.organisationId]);
  const activeEmployees = attendanceData.filter(
    (x) => String(x.active).toLowerCase() === "true",
  );

  const closedEmployees = attendanceData.filter(
    (x) => String(x.active).toLowerCase() === "false",
  );
const selectedWorkingDays = workingDaysList.find(
  (w) => String(w.workingDaysId) === String(selectedWorkingDaysId)
);
  return (
    <div className="p-4 bg-white rounded shadow-sm">
      {/* ================= Calculate Attendance ================= */}
      <h5 className="mb-3 fw-semibold">Calculate Attendance</h5>

      <Form className="mb-4 p-3 bg-light rounded border">
        <Row className="align-items-end g-3">
          <Col xs={12} md={4} lg={3}>
            <Form.Group>
              <Form.Label className="fw-medium">Working Month</Form.Label>
              <Form.Select
                value={selectedWorkingDaysId}
                onChange={(e) => setSelectedWorkingDaysId(e.target.value)}
              >
                <option value="">Select Month</option>
                {workingDaysList.map((item) => (
                  <option key={item.workingDaysId} value={item.workingDaysId}>
                    {item.workingYear}-{item.workingMonth}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col xs={12} md="auto">
            <Button
              variant="success"
              className="px-4"
              disabled={!selectedWorkingDaysId || calculateLoading}
              onClick={calculateAttendance}
            >
              {calculateLoading ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Calculating...
                </>
              ) : (
                "Calculate Attendance"
              )}
            </Button>
          </Col>
        </Row>

        {successMessage && (
          <Alert variant="success" className="mt-3 mb-0">
            {successMessage}
          </Alert>
        )}
      </Form>

      {/* ================= Attendance Summary ================= */}
      <h5 className="mb-3 fw-semibold">Attendance Summary</h5>

      <Form className="mb-4">
        <Row className="align-items-end g-3">
          <Col xs={12} md={4} lg={3}>
            <Form.Group>
              <Form.Label className="fw-medium">Working Month</Form.Label>
              <Form.Select
                value={selectedWorkingDaysId}
                onChange={(e) => setSelectedWorkingDaysId(e.target.value)}
              >
                <option value="">Select Month</option>
                {workingDaysList.map((item) => (
                  <option key={item.workingDaysId} value={item.workingDaysId}>
                    {item.workingYear}-{item.workingMonth} 
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col xs={12} md="auto">
            <Button
              variant="primary"
              className="px-4"
              disabled={!selectedWorkingDaysId || loading}
              onClick={fetchAttendance}
            >
              {loading ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Loading
                </>
              ) : (
                "Submit"
              )}
            </Button>
          </Col>
        </Row>
      </Form>
{selectedWorkingDays && (
<div className="mt-3 mb-3 p-3 border rounded shadow-sm bg-white">
  <div className="fw-semibold fs-5 mb-2">Working Period</div>

  {selectedWorkingDays?.workingStartDate && selectedWorkingDays?.workingEndDate && (
    (() => {
      const start = new Date(selectedWorkingDays.workingStartDate);
      const end = new Date(selectedWorkingDays.workingEndDate);

      // Reverse display (End → Start)
      const formattedStart = start.toISOString().split("T")[0];
      const formattedEnd = end.toISOString().split("T")[0];

      // Calculate difference in days
      const diffTime = Math.abs(end - start);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

      return (
        <div className="fs-5">
          {formatDate(selectedWorkingDays?.workingStartDate)}
    {"  to  "}
    {formatDate(selectedWorkingDays?.workingEndDate)}
          <div className="mt-2 text-primary">
            Total Working Days: {diffDays}
          </div>
        </div>
      );
    })()
  )}
</div>

)}



      {attendanceData.length > 0 && (
        <>
{/* smit_mavro
        {activeEmployees.length > 0 && (
//             <>
//               <h6 className="fw-semibold mb-2">Active Attendance Employees</h6>

//               <Table bordered hover responsive size="sm">
//                 <thead>
//                   <tr>
//                     <th className="text-center">
//                       <Form.Check
//                         type="checkbox"
//                         checked={
//                           activeEmployees.length > 0 &&
//                           activeEmployees.every((emp) =>
//                             selectedResources.some(
//                               (r) => r.resourceId === emp.resourceId,
//                             ),
//                           )
//                         }
//                         onChange={(e) => toggleSelectAll(e.target.checked)}
//                       />
//                     </th>
//                     <th>Resource ID</th>
//                     <th>Resource Name</th>
//                     <th className="text-center">Calendar Days</th>
//                     <th className="text-center">Leave Days</th>
//                     <th className="text-center">Unpaid Leaves</th>
//                     <th>Leave Details</th>
//                     <th className="text-center">Paid Days</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {activeEmployees.map((row, index) => (
//                     <tr key={row.resourceId}>
//                       <td className="text-center">
//                         <Form.Check
//                           type="checkbox"
//                           checked={selectedResources.some(
//                             (r) => r.resourceId === row.resourceId,
//                           )}
//                           onChange={() => toggleResource(row)}
//                         />
//                       </td>

//                       <td>{row.resourceId}</td>
//                       <td>{row.resourceName}</td>
//                       <td className="text-center">{row.calendarDays}</td>
//                       <td className="text-center">{row.leaveDays}</td>
//                       <td className="text-center">
//                         {row?.calendarDays - row.salaryDays}
//                       </td>
//                       <td>
//                         {row.leaves?.length > 0 ? (
//                           row.leaves.map((leave, i) => (
//                             <div
//                               key={i}
//                               className="d-flex justify-content-between bg-light px-2 py-1 rounded mb-1"
//                             >
//                               <span>{leave.leaveName}</span>
//                               <strong>{leave.leave_Days}</strong>
//                             </div>
//                           ))
//                         ) : (
//                           <em className="text-muted">No leaves</em>
//                         )}
//                       </td>

//                       <td className="text-center">
//                         <span className="badge bg-success">
//                           {row.salaryDays}
//                         </span>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </>
//           )}
//         </>
//       )}
//       <div className="d-flex justify-content-end mb-3">
//         <Button
//           variant="success"
//           disabled={submitting || selectedResources.length === 0}
//           onClick={submitSelectedAttendance}
//         >
//           {submitting ? (
//             <>
//               <Spinner size="sm" className="me-2" />
//               Submitting...
//             </>
//           ) : (
//             `Submit Attendance (${selectedResources.length})`
//           )}
//         </Button>
//       </div>
//       {closedEmployees.length > 0 && (
//         <>
//           <h6 className="fw-semibold mt-4 text-danger">
//             Closed Attendance Employees
//           </h6>

//           <Table bordered hover responsive size="sm">
//             <thead>
//               <tr>
//                 <th>Resource ID</th>
//                 <th>Resource Name</th>
//                 <th className="text-center">Calendar Days</th>
//                 <th className="text-center">Leave Days</th>
//                 <th>Leave Details</th>
//                 <th className="text-center">Paid Days</th>
//               </tr>
//             </thead>

//             <tbody>
//               {closedEmployees.map((row) => (
//                 <tr key={row.resourceId} className="table-secondary">
//                   <td>{row.resourceId}</td>
//                   <td>{row.resourceName}</td>
//                   <td className="text-center">{row.calendarDays}</td>
//                   <td className="text-center">{row.leaveDays}</td>

//                   <td>
//                     {row.leaves?.length > 0 ? (
//                       row.leaves.map((leave, i) => (
//                         <div
//                           key={i}
//                           className="d-flex justify-content-between bg-light px-2 py-1 rounded mb-1"
//                         >
//                           <span>{leave.leaveName}</span>
//                           <strong>{leave.leave_Days}</strong>
//                         </div>
//                       ))
//                     ) : (
//                       <em className="text-muted">No leaves</em>
//                     )}
//                   </td>

//                   <td className="text-center">
//                     <span className="badge bg-secondary">{row.salaryDays}</span>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//         </>
//       )}
// =======*/}
 {activeEmployees.length > 0 && (
  <>
    <h6 className="fw-semibold mb-2">Active Attendance Employees</h6>

    <Table bordered hover responsive size="sm">
      <thead>
        <tr>
          <th className="text-center">
            <Form.Check
              type="checkbox"
              checked={
  activeEmployees.length > 0 &&
  activeEmployees.every(emp =>
    selectedResources.some(r => r.resourceId === emp.resourceId)
  )
}

              onChange={(e) => toggleSelectAll(e.target.checked)}
            />
          </th>
          <th>Resource ID</th>
          <th>Resource Name</th>
          <th className="text-center">Calendar Days</th>
          <th className="text-center">Leave Days</th>
          <th className="text-center">Unpaid Leaves</th>
          <th>Leave Details</th>
          <th className="text-center">Paid Days</th>
        </tr>
      </thead>

      <tbody>
        {activeEmployees.map((row, index) => (
          <tr key={row.resourceId}>
            <td className="text-center">
              <Form.Check
                type="checkbox"
                checked={selectedResources.some(r => r.resourceId === row.resourceId)}
                onChange={() => toggleResource(row)}
              />
            </td>

            <td>{row.resourceId}</td>
            <td>{row.resourceName}</td>
            <td className="text-center">{row.calendarDays}</td>
            <td className="text-center">{row.leaveDays}</td>
 <td className="text-center">{row?.calendarDays - row.salaryDays}</td>
            <td>
              {row.leaves?.length > 0 ? (
                row.leaves.map((leave, i) => (
                  <div key={i} className="d-flex justify-content-between bg-light px-2 py-1 rounded mb-1">
                    <span>{leave.leaveName}</span>
                    <strong>{leave.leave_Days}</strong>
                  </div>
                ))
              ) : (
                <em className="text-muted">No leaves</em>
              )}
            </td>
           
            <td className="text-center">
              <span className="badge bg-success">
                {row.salaryDays}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </>
)} 

  </>
      )}
      <div className="d-flex justify-content-end mb-3">
  <Button
    variant="success"
    disabled={submitting || selectedResources.length === 0}
    onClick={submitSelectedAttendance}
  >
    {submitting ? (
      <>
        <Spinner size="sm" className="me-2" />
        Submitting...
      </>
    ) : (
      `Submit Attendance (${selectedResources.length})`
    )}
  </Button>


</div>
  {closedEmployees.length > 0 && (
  <>
    <h6 className="fw-semibold mt-4 text-danger">
      Closed Attendance Employees
    </h6>

    <Table bordered hover responsive size="sm">
      <thead>
        <tr>
          <th>Resource ID</th>
          <th>Resource Name</th>
          <th className="text-center">Calendar Days</th>
          <th className="text-center">Leave Days</th>
          <th className="text-center">Unpaid Leaves</th>
          <th>Leave Details</th>
          <th className="text-center">Paid Days</th>
        </tr>
      </thead>

      <tbody>
        {closedEmployees.map(row => (
          <tr key={row.resourceId} className="table-secondary">
            <td>{row.resourceId}</td>
            <td>{row.resourceName}</td>
            <td className="text-center">{row.calendarDays}</td>
            <td className="text-center">{row.leaveDays}</td>
             <td className="text-center">{row?.calendarDays - row.salaryDays}</td>

            <td>
              {row.leaves?.length > 0 ? (
                row.leaves.map((leave, i) => (
                  <div key={i} className="d-flex justify-content-between bg-light px-2 py-1 rounded mb-1">
                    <span>{leave.leaveName}</span>
                    <strong>{leave.leave_Days}</strong>
                  </div>
                ))
              ) : (
                <em className="text-muted">No leaves</em>
              )}
            </td>

            <td className="text-center">
              <span className="badge bg-secondary">
                {row.salaryDays}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </>
)}


    </div>
  );
}
